import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { getApiUrl } from "./config";

function Login() {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
const navigate = useNavigate();
  const login = () => {

  axios.post(`${getApiUrl()}/login`, {
    email,
    password
  })
  .then(res => {

    if (res.data.status === "success") {

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("role", res.data.role || "user");
      if (res.data.customer_id) localStorage.setItem("customer_id", String(res.data.customer_id));
      else localStorage.removeItem("customer_id");
      axios.defaults.headers.common.Authorization = `Bearer ${res.data.token}`;

      if ((res.data.role || "user") === "customer") {
        navigate("/customer/bills");
      } else {
        navigate("/dashboard"); // ✅ redirect
      }

    } else {
      alert("Invalid Login");
    }

  });

};

  return (

    <div className="container d-flex justify-content-center align-items-center vh-100">

      <div className="card shadow-lg p-4" style={{width:"350px", borderRadius:"15px"}}>

        <h3 className="text-center mb-4">Login</h3>

        <div className="mb-3">
          <label className="form-label">Email</label>
          <input
            type="email"
            className="form-control"
            placeholder="Enter email"
            onChange={e => setEmail(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Password</label>
          <input
            type="password"
            className="form-control"
            placeholder="Enter password"
            onChange={e => setPassword(e.target.value)}
          />
        </div>

        <button className="btn btn-primary w-100" onClick={login}>
          Login
        </button>

        <div className="text-center mt-3">
          <small className="text-muted">
            Forgot Password?
          </small>
        </div>

      </div>

    </div>
  );
}

export default Login;
